/**
 * Mercola Market — Global JavaScript
 *
 * Handles: variant selection, autoship toggle, breadcrumbs,
 * newsletter form feedback.
 */
(function() {
  'use strict';

  // Shipping page HTML is managed in Shopify Pages. Keep its tab behavior
  // in the theme: page-content script tags are not a reliable initializer.
  function initializeShippingTabs(root) {
    root.querySelectorAll('.shipping-page').forEach(function(page) {
      if (page.dataset.shippingTabsReady === 'true') return;
      var tabs = Array.from(page.querySelectorAll('.shipping-page__tab[role="tab"]'));
      var panels = Array.from(page.querySelectorAll('.shipping-page__panel[role="tabpanel"]'));
      var pairs = tabs.map(function(tab) {
        var panelId = tab.id.replace('shipping-tab-', 'shipping-panel-');
        return { tab: tab, panel: panels.find(function(panel) { return panel.id === panelId; }) };
      });
      if (!pairs.length || pairs.some(function(pair) { return !pair.panel; })) return;
      page.dataset.shippingTabsReady = 'true';
      function activate(index, focus) {
        pairs.forEach(function(pair, i) {
          var selected = i === index;
          pair.tab.setAttribute('aria-controls', pair.panel.id);
          pair.tab.setAttribute('aria-selected', String(selected));
          pair.tab.tabIndex = selected ? 0 : -1;
          pair.panel.setAttribute('aria-labelledby', pair.tab.id);
          pair.panel.hidden = !selected;
          if (selected && focus) pair.tab.focus();
        });
      }
      pairs.forEach(function(pair, index) {
        pair.tab.addEventListener('click', function() { activate(index, false); });
        pair.tab.addEventListener('keydown', function(event) {
          var next;
          if (event.key === 'ArrowRight') next = (index + 1) % pairs.length;
          else if (event.key === 'ArrowLeft') next = (index + pairs.length - 1) % pairs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = pairs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0, false);
    });
  }
  document.addEventListener('DOMContentLoaded', function() { initializeShippingTabs(document); });
  document.addEventListener('shopify:section:load', function(event) { initializeShippingTabs(event.target); });

  // ============================================================
  // Product-card swatches
  // ============================================================
  // Merchant-entered option values must not be interpolated into a style
  // attribute. Let the browser validate each value as a CSS color before
  // assigning it to the narrow backgroundColor property.
  function applyProductCardSwatches(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var swatches = scope.querySelectorAll('[data-swatch-color]');

    swatches.forEach(function(swatch) {
      var value = (swatch.getAttribute('data-swatch-color') || '').trim();
      if (!value || !window.CSS || !window.CSS.supports('color', value)) return;
      swatch.style.backgroundColor = value;
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    applyProductCardSwatches(document);
  });
  document.addEventListener('shopify:section:load', function(event) {
    applyProductCardSwatches(event.target);
  });

  // ============================================================
  // Autoship Toggle
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    var toggle = document.querySelector('[data-autoship-toggle]');
    if (!toggle) return;

    toggle.addEventListener('change', function() {
      var isAutoship = this.checked;
      var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      var priceDisplay = document.querySelector('[data-autoship-price]');
      var regularPrice = document.querySelector('[data-regular-price]');

      if (isAutoship && sellingPlanInput) {
        // Set the selling plan ID (5% autoship discount)
        var planId = this.getAttribute('data-selling-plan-id');
        sellingPlanInput.value = planId || '';
        if (priceDisplay) priceDisplay.style.display = 'block';
        if (regularPrice) regularPrice.style.display = 'none';
      } else if (sellingPlanInput) {
        sellingPlanInput.value = '';
        if (priceDisplay) priceDisplay.style.display = 'none';
        if (regularPrice) regularPrice.style.display = 'block';
      }
    });
  });

  // ============================================================
  // Newsletter Form Feedback
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('newsletter-form') ||
               document.querySelector('.newsletter-section__form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      // Shopify handles the form submission — show feedback after redirect
      var emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        // Store success flag for after redirect
        sessionStorage.setItem('newsletter_submitted', '1');
      }
    });

    // Check if we just submitted
    if (sessionStorage.getItem('newsletter_submitted')) {
      sessionStorage.removeItem('newsletter_submitted');
      var statusEl = document.createElement('div');
      statusEl.className = 'newsletter-section__success';
      statusEl.textContent = 'Thank you for subscribing!';
      statusEl.style.cssText = 'text-align:center;color:#2d5f3f;font-size:14px;font-weight:600;padding:12px 0;';
      var section = document.querySelector('.newsletter-section__inner');
      if (section) {
        var formEl = section.querySelector('form');
        if (formEl) formEl.style.display = 'none';
        section.appendChild(statusEl);
      }
    }
  });

  // ============================================================
  // Mobile Menu
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');

    if (openBtn && menu) {
      openBtn.addEventListener('click', function() {
        menu.hidden = false;
        menu.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeBtn && menu) {
      closeBtn.addEventListener('click', function() {
        menu.hidden = true;
        menu.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
    // Close on backdrop click
    if (menu) {
      menu.addEventListener('click', function(e) {
        if (e.target === menu) {
          menu.hidden = true;
          menu.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    }
  });

  // ============================================================
  // Variant Selector (Default Title fix)
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    // Hide variant selector if only "Default Title" exists
    var selectors = document.querySelectorAll('.product-form__input');
    selectors.forEach(function(sel) {
      var label = sel.querySelector('legend, label');
      if (label && label.textContent.trim() === 'Default Title') {
        sel.style.display = 'none';
      }
    });
  });
})();
